import { render, staticRenderFns } from "./SundryCreditorDetail.vue?vue&type=template&id=41964054&scoped=true"
import script from "./SundryCreditorDetail.vue?vue&type=script&lang=js"
export * from "./SundryCreditorDetail.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorDetail.vue?vue&type=style&index=0&id=41964054&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41964054",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41964054')) {
      api.createRecord('41964054', component.options)
    } else {
      api.reload('41964054', component.options)
    }
    module.hot.accept("./SundryCreditorDetail.vue?vue&type=template&id=41964054&scoped=true", function () {
      api.rerender('41964054', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorDetail.vue"
export default component.exports